import React from 'react';
import PropTypes from 'prop-types';
import { MenuLabelTag } from './styles';
import { SvgCheck } from '../../svg';

const MenuLabel = ({ done, active, style, children, withCursor, onClick, ...rest }) => (
  <MenuLabelTag
    done={done}
    active={active}
    style={{ ...style }}
    withCursor={!!withCursor || !!onClick}
    {...rest}
  >
    {done && !active ? <SvgCheck width="14px" height="15px" /> : <span />}
    {children}
  </MenuLabelTag>
);

MenuLabel.propTypes = {
  done: PropTypes.bool,
  active: PropTypes.bool,
  type: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MenuLabel;
